import { getUserFavorites, deleteUserFavorite } from '@/api/favorites.js'

export default {
  namespaced: true,
  state: {
    strategies: [],
    goals: [],
    collectionId: '',
    filters: {
      goals: 'All Subjects',
      strategies: 'All Subjects'
    },
    loaded: false
  },
  mutations: {
    setGoals(state, goals) {
      state.goals = goals
    },
    setStrategies(state, strategies) {
      state.strategies = strategies
    },
    setCollectionId(state, cid) {
      state.collectionId = cid
    },
    removeFavorite(state, info) {
      if (info.type === 'strategy') {
        state.strategies = state.strategies.filter(strat => {
          return strat.content_uuid !== info.uuid
        })
      } else if (info.type === 'goal' || info.type === 'super_page') {
        state.goals = state.goals.filter(goal => {
          return goal.content_uuid !== info.uuid
        })
      }
    },
    setFilter(state, info) {
      state.filters[info.type] = info.filter
    },
    setLoading(state, bool) {
      state.loaded = bool
    }
  },
  actions: {
    fetchPageContent(context, userId) {
      context.commit('setLoading', false)
      return getUserFavorites(userId, { full: true }).then(data => {
        context.commit('setLoading', true)
        console.dir(data)
        let strategies = []
        let goals = []
        if (data.collection) {
          context.commit('setCollectionId', data.collection.uuid)
        }
        if (data.collection && data.collection.content) {
          data.collection.content.forEach(resource => {
            if (resource.content_type === 'goal' || resource.content_type === 'super_page') {
              goals.push(resource)
            } else if (resource.content_type === 'strategy') {
              strategies.push(resource)
            }
          })
        }
        context.commit('setGoals', goals)
        context.commit('setStrategies', strategies)
      })
    },
    deleteFavorite(context, info) {
      return deleteUserFavorite(info.uuid).then(() => {
        context.commit('removeFavorite', info)
      })
    },
    setFilter(context, info) {
      return context.commit('setFilter', info)
    }
  }
}
